import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  href: "#top"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "toptotop",
  src: "/images/scrollto1.png"
}, null, -1);

const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "bottomtotop",
  src: "/images/scrollto2.png"
}, null, -1);

const _hoisted_4 = [_hoisted_2, _hoisted_3];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_smooth_scroll = _resolveDirective("smooth-scroll");

  return _openBlock(), _createElementBlock("footer", null, [_createElementVNode("div", {
    class: _normalizeClass(["scrolltop animate__animated animate__bounceIn", {
      totopactive: $data.totop
    }])
  }, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_1, _hoisted_4)), [[_directive_smooth_scroll]])], 2)]);
}